import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { faBriefcase } from "@fortawesome/pro-light-svg-icons/faBriefcase";
import { faCalendar } from "@fortawesome/pro-light-svg-icons/faCalendar";
import { faCertificate } from "@fortawesome/pro-light-svg-icons/faCertificate";
import { faCircleCheck } from "@fortawesome/pro-light-svg-icons/faCircleCheck";
import { faCircleDollar } from "@fortawesome/pro-light-svg-icons/faCircleDollar";
import { faComments } from "@fortawesome/pro-light-svg-icons/faComments";
import { faDollarSign } from "@fortawesome/pro-light-svg-icons/faDollarSign";
import { faFamily } from "@fortawesome/pro-light-svg-icons/faFamily";
import { faLeaf } from "@fortawesome/pro-light-svg-icons/faLeaf";
import { faMedal } from "@fortawesome/pro-light-svg-icons/faMedal";
import { faPerson } from "@fortawesome/pro-light-svg-icons/faPerson";
import { faPersonDollyEmpty } from "@fortawesome/pro-light-svg-icons/faPersonDollyEmpty";
import { faThumbsUp } from "@fortawesome/pro-light-svg-icons/faThumbsUp";
import { faVenus } from "@fortawesome/pro-light-svg-icons/faVenus";
import { ContractorAttribute } from "@yardzen/api-dtos";

type AttributeMappingType = {
  [key in ContractorAttribute]: {
    displayName: string;
    icon: IconDefinition | null;
  };
};

export const attributeMapping: AttributeMappingType = {
  [ContractorAttribute.BOOKING_FAST]: {
    displayName: "Booking Fast",
    icon: faCalendar,
  },
  [ContractorAttribute.RESPONSIVE_COMMUNICATION]: {
    displayName: "Responsive Communication",
    icon: faComments,
  },
  [ContractorAttribute.PREMIUM_EXPERIENCE]: {
    displayName: "Premium Experience",
    icon: faCircleDollar,
  },
  [ContractorAttribute.VALUE_PRO]: {
    displayName: "Value Pro",
    icon: faDollarSign,
  },
  [ContractorAttribute.YARDZEN_APPROVED]: {
    displayName: "Yardzen Approved",
    icon: faThumbsUp,
  },
  [ContractorAttribute.YEARS_IN_BUSINESS]: {
    displayName: "Years in Business",
    icon: faCircleCheck,
  },
  [ContractorAttribute.FREE_ESTIMATES]: {
    displayName: "Free Estimates",
    icon: faBriefcase,
  },
  [ContractorAttribute.ECO_FRIENDLY]: {
    displayName: "Eco friendly",
    icon: faLeaf,
  },
  [ContractorAttribute.FEMALE_FOUNDED]: {
    displayName: "Female Founded",
    icon: faVenus,
  },
  [ContractorAttribute.BIPOC_OWNED]: {
    displayName: "BIPOC Owned",
    icon: faMedal,
  },
  [ContractorAttribute.VETERAN_OWNED]: {
    displayName: "Veteran Owned",
    icon: faPerson,
  },
  [ContractorAttribute.OWNER_OPERATED]: {
    displayName: "Owner Operator",
    icon: faPersonDollyEmpty,
  },
  [ContractorAttribute.FAMILY_OWNED]: {
    displayName: "Family Owned",
    icon: faFamily,
  },
  [ContractorAttribute.PTI_ELITE_BUILDER]: {
    displayName: "PTI - Elite Builder",
    icon: faCertificate,
  },
  [ContractorAttribute.PTI_CERTIFIED_BUILDER]: {
    displayName: "PTI - Certified Builder",
    icon: faCertificate,
  },
  [ContractorAttribute.SUPER_PRO]: {
    displayName: "Super Pro",
    icon: null,
  },
  [ContractorAttribute.LICENSED]: {
    displayName: "Licensed",
    icon: null,
  },
  [ContractorAttribute.BONDED]: {
    displayName: "Bonded",
    icon: null,
  },
  [ContractorAttribute.INSURED]: {
    displayName: "Insured",
    icon: null,
  },
  [ContractorAttribute.TOLL_BROTHERS_PREFERRED]: {
    displayName: "Toll Brothers Preferred",
    icon: faMedal,
  },
};
